export default __webpack_public_path__ + "static/media/lime.3f07a9da.svg";